module.exports = __webpack_public_path__ + "img/santos-da-lapa.c095998a.jpg";